import bootstrap from 'bootstrap'
class collapses {
  _construct() {
  }

  init() {
    $('.collapse').collapse({
      toggle: false
    })
  }
}

export default collapses
